import React, { useEffect, useContext } from "react";
import AppContext from "../contexts/AppContext";
import { useLocation, Link, matchPath } from "react-router-dom";
import { useHistory } from "react-router";
// @material-ui/core components
import { setRedmine } from "../actions";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import Menu from "@material-ui/core/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// @material-ui/icons components
import Clear from "@material-ui/icons/Clear";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ExpandMore from "@material-ui/icons/ExpandMore";
import AccountTreeTwoTone from "@material-ui/icons/AccountTreeTwoTone";
import BookmarksTwoToneIcon from "@material-ui/icons/BookmarksTwoTone";
import { Hub } from "aws-amplify";

import { setIssueFilter, RESET_SEARCH } from "../actions";
import SidebarProjectList from "../components/sidebar_project_list";
import SidebarBookmarkList from "./sidebar_bookmarks_list";
import IssueFilter from "../components/issue_filter";
import { useConfig } from "../hooks/useConfig";

import { useTranslation } from "react-i18next";

import { sidebarItems } from "../routes";
import componentStyles from "../assets/styles/components/sidebar";
const useStyles = makeStyles(componentStyles);

export default function Sidebar({ logo, dropdown }) {
  const { state, dispatch } = useContext(AppContext);
  const { readConfig } = useConfig();

  const classes = useStyles();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setIssueFilter(dispatch, createFilter());
    readConfig();
    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signIn":
          readConfig();
          break;
        default:
      }
    });
  }, []);

  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = () => {
    dispatch({ type: RESET_SEARCH });
    setAnchorEl(null);
  };

  const menuId = "responsive-menu-id";
  const createIssuesPath = (path) => {
    if (path !== "/project/:id/issues") {
      return path;
    }

    let issuesPath;
    if (state.current.project && Object.keys(state.current.project).length) {
      // console.log(state.current.project.id)
      issuesPath = `/project/${state.current.project.id}/issues`;
    } else {
      issuesPath = `/project/issues`;
    }
    // console.log(issuesPath)
    return issuesPath;
  };
  const shouldSelected = (path) => {
    if (path === "/project/:id/issues") {
      return matchPath(location.pathname, { path: path, exact: true }) ||
        matchPath(location.pathname, { path: "/project/issues", exact: true })
        ? true
        : false;
    } else {
      return matchPath(location.pathname, { path: path, exact: true })
        ? true
        : false;
    }
  };
  const shouldDisabled = (path) => {
    if (path === "/project/:id/issues" || path === "/projects") {
      if (!state.current.name) {
        return true;
      }
    }
    return false;
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = () => {
    return sidebarItems.map((prop, key) => {
      let textContent = (
        <>
          <Box minWidth="2.25rem" display="flex" alignItems="center">
            {typeof prop.icon === "string" ? (
              <Box
                component="i"
                className={prop.icon + " " + classes["text" + prop.iconColor]}
              />
            ) : null}
            {typeof prop.icon === "object" ? (
              <Box
                component={prop.icon}
                width="1.25rem!important"
                height="1.25rem!important"
                className={classes["text" + prop.iconColor]}
              />
            ) : null}
          </Box>
          {t(prop.name)}
        </>
      );
      return (
        <ListItem
          key={key}
          component={Link}
          button
          onClick={handleMenuClick}
          to={createIssuesPath(prop.path)}
          classes={{
            root: classes.listItemRoot,
            selected: classes.listItemSelected,
          }}
          selected={shouldSelected(prop.path)}
          disabled={shouldDisabled(prop.path)}
        >
          {textContent}
        </ListItem>
      );
    });
  };
  let logoImage = (
    <img alt={logo.imgAlt} className={classes.logoClasses} src={logo.imgSrc} />
  );
  let logoObject =
    logo && logo.innerLink ? (
      <Link to={logo.innerLink} className={classes.logoLinkClasses}>
        {logoImage}
      </Link>
    ) : logo && logo.outterLink ? (
      <a href={logo.outterLink} className={classes.logoLinkClasses}>
        {logoImage}
      </a>
    ) : null;

  const createFilter = (filter = {}) => {
    let status_id;
    let author_id;
    let assigned_to;

    if (state.current.issueFilter) {
      status_id = state.current.issueFilter.status_id;
      author_id = state.current.issueFilter.author_id;
      assigned_to = state.current.issueFilter.assigned_to;
    } else {
      status_id = "";
      author_id = "";
      assigned_to = "";
    }
    let result = { status_id, author_id, assigned_to };
    return { ...result, ...filter };
  };

  const handleChangeFilterStatus = (event) => {
    setIssueFilter(dispatch, createFilter({ status_id: event.target.value }));
  };

  const handleChangeFilterAuthor = (event) => {
    setIssueFilter(dispatch, createFilter({ author_id: event.target.value }));
  };

  const handleChangeFilterAssignedTo = (event) => {
    setIssueFilter(dispatch, createFilter({ assigned_to: event.target.value }));
  };

  const handleClickResetFilter = (event) => {
    setIssueFilter(dispatch, {
      status_id: "",
      author_id: "",
      assigned_to: "",
    });
  };

  return (
    <>
      <Hidden smDown implementation="css">
        <Drawer variant="permanent" anchor="left" open>
          <Box paddingBottom="1rem">{logoObject}</Box>
          <List classes={{ root: classes.listRoot }}>
            <SidebarRedmineProjectsUI />
            {createLinks(sidebarItems)}

            <Divider classes={{ root: classes.divider }} />
            {matchPath(location.pathname, {
              path: "/project/:id/issues",
              exact: true,
            }) ||
            matchPath(location.pathname, {
              path: "/project/issues",
              exact: true,
            }) ? (
              <IssueFilter
                handleChangeStatusfunc={handleChangeFilterStatus}
                handleChangeAuthorfunc={handleChangeFilterAuthor}
                handleChangeAssignedTofunc={handleChangeFilterAssignedTo}
                handleClickResetfunc={handleClickResetFilter}
              />
            ) : (
              ""
            )}
          </List>
        </Drawer>
      </Hidden>
      <Hidden mdUp implementation="css">
        <AppBar position="relative" color="default" elevation={0}>
          <Toolbar>
            <Container
              display="flex!important"
              justifyContent="space-between"
              alignItems="center"
              marginTop=".75rem"
              marginBottom=".75rem"
              component={Box}
              maxWidth={false}
              padding="0!important"
            >
              <Box
                component={MenuIcon}
                width="2rem!important"
                height="2rem!important"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleMenuOpen}
              />
              {logoObject}
              {dropdown}
            </Container>
          </Toolbar>
        </AppBar>
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          id={menuId}
          keepMounted
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={isMenuOpen}
          onClose={handleMenuClick}
          classes={{ paper: classes.menuPaper }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            paddingLeft="1.25rem"
            paddingRight="1.25rem"
            paddingBottom="1rem"
            className={classes.outlineNone}
          >
            {logoObject}
            <Box
              component={Clear}
              width="2rem!important"
              height="2rem!important"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleMenuClick}
            />
          </Box>
          <Box
            component={Divider}
            marginBottom="1rem!important"
            marginLeft="1.25rem!important"
            marginRight="1.25rem!important"
          />
          <SidebarRedmineProjectsUI setAnchorEl={setAnchorEl} />
          <List classes={{ root: classes.listRoot }}>
            {createLinks(sidebarItems)}
          </List>
          <Divider classes={{ root: classes.divider }} />
          {matchPath(location.pathname, {
            path: "/project/:id/issues",
            exact: true,
          }) ||
          matchPath(location.pathname, {
            path: "/project/issues",
            exact: true,
          }) ? (
            <IssueFilter
              handleChangeStatusfunc={handleChangeFilterStatus}
              handleChangeAuthorfunc={handleChangeFilterAuthor}
              handleChangeAssignedTofunc={handleChangeFilterAssignedTo}
              handleClickResetfunc={handleClickResetFilter}
            />
          ) : (
            ""
          )}
        </Menu>
      </Hidden>
    </>
  );
}

const SidebarRedmineProjectsUI = (props) => {
  const { setAnchorEl } = props;
  const { state, dispatch } = useContext(AppContext);
  const [projectsCollapse, setProjectsCollapse] = React.useState(false);
  const [bookmarksCollapse, setBookmarksCollapse] = React.useState(false);
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  const handleChangeConfig = (e) => {
    const config = state.siteConfigs.find(
      (config) => config.id === e.target.value
    );
    setRedmine(dispatch, config);
    const matchIssues = matchPath(location.pathname, {
      path: "/project/:id/issues",
      exact: true,
    });
    const matchIssueDetail = matchPath(location.pathname, {
      path: "/issue/:id",
      exact: true,
    });
    if (matchIssues || matchIssueDetail) {
      history.push("/project/issues");
    }
  };

  const handleProjectsClick = () => {
    setProjectsCollapse(!projectsCollapse);
  };

  const handleBookmarksClick = () => {
    setBookmarksCollapse(!bookmarksCollapse);
  };

  return (
    <>
      <Typography variant="h6" component="h6" classes={{ root: classes.title }}>
        Redmine
      </Typography>

      <FormGroup>
        <FormControl variant="filled" component={Box} width="100%">
          <Box paddingLeft="1.5rem" paddingRight="1.5rem">
            <Select
              id="current-redmine"
              value={state.current.id ? state.current.id : ""}
              onChange={handleChangeConfig}
              displayEmpty
            >
              <MenuItem value="">
                <em>Redmineを選択してください</em>
              </MenuItem>
              {state.siteConfigs
                ? state.siteConfigs.map((config, index) => {
                    return (
                      <MenuItem key={index} value={config.id}>
                        {config.name}
                      </MenuItem>
                    );
                  })
                : ""}
            </Select>
          </Box>
        </FormControl>
      </FormGroup>

      <Divider classes={{ root: classes.divider }} />

      <ListItem
        button
        classes={{
          root: classes.listItemRoot,
          selected: classes.listItemSelected,
        }}
        onClick={handleBookmarksClick}
      >
        <Box minWidth="2.25rem" display="flex" alignItems="center">
          <Box
            component={BookmarksTwoToneIcon}
            width="1.25rem!important"
            height="1.25rem!important"
            className={classes["textError"]}
          />
        </Box>
        <ListItemText
          primary={
            <Typography style={{ fontSize: "0.9rem" }}>
              {t("label_bookmarks")}
            </Typography>
          }
        />
        {bookmarksCollapse ? <ExpandMore /> : <ChevronRight />}
      </ListItem>
      <Collapse in={bookmarksCollapse} timeout="auto">
        <SidebarBookmarkList setAnchorEl={setAnchorEl} />
      </Collapse>

      <Divider classes={{ root: classes.divider }} />

      <ListItem
        button
        classes={{
          root: classes.listItemRoot,
          selected: classes.listItemSelected,
        }}
        onClick={handleProjectsClick}
      >
        <Box minWidth="2.25rem" display="flex" alignItems="center">
          <Box
            component={AccountTreeTwoTone}
            width="1.25rem!important"
            height="1.25rem!important"
            className={classes["textInfo"]}
          />
        </Box>
        <ListItemText
          primary={
            <Typography style={{ fontSize: "0.9rem" }}>
              {t("label_project")}
            </Typography>
          }
        />
        {projectsCollapse ? <ExpandMore /> : <ChevronRight />}
      </ListItem>
      <Collapse in={projectsCollapse} timeout="auto">
        <SidebarProjectList setAnchorEl={setAnchorEl} />
      </Collapse>

      <Divider classes={{ root: classes.divider }} />
    </>
  );
};
